import { Autocomplete, Box, FormControl, TextField, Typography } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import theme from "css/theme/light"
import { FC, useContext, useEffect, useState } from "react"
import { IFormDepartmentProps } from "./formdepartmentpicker.interface"
import { useTranslation } from "react-i18next"
import { StyledFormLabel } from "shared/styled/Global"

function isJsonString(str: any) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const FormDepartmentPicker: FC<IFormDepartmentProps> = (props) => {
  const { id, labelKey, labelDefault, handleChange, value, optional, error, helperText, handleBlur } = props
  const [options, setOptions] = useState<Array<{ label: string; value: string }>>()
  const appContext = useContext(AppContext)
  const { t } = useTranslation()

  useEffect(() => {
    const companies = appContext.appUser.customer.companies
    const allDepartments = companies
      .flatMap((company: any) => company.departments)
      .map((department: any) => ({
        label: department.name,
        value: department.id
      }))
    setOptions(allDepartments)
  }, [])

  return (
    <Box my={0.75}>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })} {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      <FormControl fullWidth>
        <Autocomplete
          loading
          loadingText={`${t("global.loading", "Loading")}...`}
          sx={{ width: "100%", background: theme.palette.background.paper }}
          id={id?.toString()}
          options={options ? options : []}
          getOptionLabel={(option) => option?.label}
          onChange={(e, option) => handleChange && handleChange(option?.value || "")}
          includeInputInList
          value={
            options?.find(
              (i) =>
                i.value?.toString() === value?.toString() ||
                (isJsonString(value) && i.value?.toString() === JSON.parse(value)?.Id?.toString())
            ) || null
          }
          renderInput={(params) => (
            <TextField
              {...params}
              name={id?.toString()}
              variant="outlined"
              error={error}
              helperText={helperText}
              onBlur={handleBlur}
            />
          )}
        />
      </FormControl>
    </Box>
  )
}

export default FormDepartmentPicker
